import { FieldProps, useFormikContext } from 'formik';
import { useCallback, useEffect } from 'react';
import { SingleRadioButtonWrapper } from '@styles/ContactManager/ContactStyles';

interface ISingleRadioButton extends FieldProps {
  dependFieldName: string;
  label: string;
}

export const SingleRadioButton = ({ field, dependFieldName, label }: ISingleRadioButton) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleChange = useCallback(() => {
    field.onChange({ target: { name: field.name, value: true } });
    setFieldValue(field.name, true);
    setFieldTouched(dependFieldName, true);
    setFieldTouched(field.name, true);
  }, [dependFieldName, field]);

  useEffect(() => {
    if (field.value) {
      field.onChange({ target: { name: dependFieldName, value: false } });
      setFieldValue(dependFieldName, false);
    }
  }, [dependFieldName, field.value]);

  return (
    <SingleRadioButtonWrapper>
      <input type="radio" id="radioButton" name={field.name} checked={field.value ?? false} onChange={handleChange} />
      <label onClick={handleChange}>{label}</label>
    </SingleRadioButtonWrapper>
  );
};
